import React, { useState, useCallback } from 'react';
import { func } from 'prop-types';
import classNames from 'classnames';

import { usePromoCart } from '../../contexts/PromoCartProvider';
import { usePromoModel } from '../../contexts/PromoModelProvider';
import { usePromoPresentation } from '../../contexts/PromoPresentationProvider';
import { noop } from '../../utils/promo-utils';
import { PromoPod } from '../promo-pod/PromoPod';
import { MessagingContainer } from './subcomponents/MessagingContainer/MessagingContainer';
import { InfoContainer } from './subcomponents/InfoContainer/InfoContainer';
import './PromoCallToAction.scss';

export const PromoCallToAction = ({ onPromoCtaHover }) => {
  const { setIsDrawerOpen, isAppleMobileDevice } = usePromoPresentation();
  const {
    isMsb, isBogo, singleItemIdToDisplay, hasProducts, itemCount
  } = usePromoModel();
  const { bogoSelectedProduct, freeItemInCart } = usePromoCart();
  const [analyticsTriggered, setAnalyticsTriggered] = useState(false);

  const handleClick = useCallback((event) => {
    const imageContainer = document.querySelector('.images-container');
    if (!imageContainer || !imageContainer.contains(event.target)) {
      onPromoCtaHover();
      setIsDrawerOpen(true);
    }

    // Analytics
    // TODO: Update thd-analytics to use .once
    if (!analyticsTriggered) {
      setAnalyticsTriggered(true);
      window.LIFE_CYCLE_EVENT_BUS.trigger('promotion-products.cta.click', {
        component: isBogo ? 'bogo' : 'multi-sku bulk',
        section: 'buybox',
        target: 'see eligible items',
      });
    }
  }, [onPromoCtaHover, setIsDrawerOpen, analyticsTriggered, setAnalyticsTriggered, isBogo]);

  const promoCallToActionClasses = classNames(
    'promo-call-to-action', {
      'promo-call-to-action--disabled': !hasProducts || singleItemIdToDisplay,
      'promo-call-to-action--vertical': isMsb,
    });

  const toBeSelectedItemId = bogoSelectedProduct?.itemId || freeItemInCart?.itemId;

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        className={promoCallToActionClasses}
        data-testid="promo-call-to-action"
        onClick={handleClick}
        onMouseEnter={!isAppleMobileDevice ? onPromoCtaHover : undefined}
        aria-label="Open Promotion Drawer"
      >
        <div className="promo-call-to-action__messaging">
          <MessagingContainer />
          {itemCount > 1 && (
            <div
              data-testid="promo-icon-open"
              className="promo-icon promo-icon-open"
            />
          )}
        </div>
        <InfoContainer />
      </div>
      {singleItemIdToDisplay && (
        <PromoPod
          key={singleItemIdToDisplay}
          itemId={singleItemIdToDisplay}
          selected={isBogo && !!toBeSelectedItemId}
          displayPosition="1"
          isInPromoDrawer={false}
        />
      )}
    </>
  );
};

PromoCallToAction.displayName = 'PromoCallToAction';

PromoCallToAction.propTypes = {
  onPromoCtaHover: func
};

PromoCallToAction.defaultProps = {
  onPromoCtaHover: noop
};
